export default __webpack_public_path__ + "static/media/MAYDOM2026.c3da2131.jpg";